import { React, useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Image, Navbar, Stack, Row, Col } from 'react-bootstrap';
import { useUserContext } from 'contexts/UserContext';
import { useConfig } from 'contexts/ConfigContext';
import { Menu } from './Menu/Menu';
import { formattedDate } from "./../../_helpers/formatDate";
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';

export function Header() {
    const { t } = useTranslation();
  const navigate = useNavigate();
    const { userData } = useUserContext();
    const { configData } = useConfig();
    const [pendingInterventions, setPendingInterventions] = useState('');
  const handleMoveHome = () => {
    navigate('/home');
    }

    const getAudits = async () => {

        const response = await api.getPendingInterventions();
        console.log(response);
        if (response.status === 200) {
            setPendingInterventions(response.data);
        }
    }

    useEffect(() => {
        getAudits();
    }, []);

    console.log(userData);


 return (
    <Container fluid className="Header">
      <Row>
        <Col>
          <Container>
            <Row>
              <Navbar expand="lg" className="align-items-center py-2">
                <Stack direction="horizontal" className="me-auto align-items-end" gap={1}>
                  <Image src="./images/tunstall-logo-reverse.png" style={{ width: '140px', cursor:'pointer' }} onClick={handleMoveHome}/>
                  <h5 className="m-0">{configData.companyName}</h5>
                </Stack>
                <div className="d-flex align-items-end gap-2">
                                 {userData && (
                                         <div>
                                             <small><b>{userData.username}</b></small>
                                         {(userData.role === "Admin" || userData.role === "UserManager") && pendingInterventions > 0 && (
                                                 <>

                                                 <Link to={'/interventionManagement'}>
                                                 <span
                                                     className="badge rounded-pill bg-warning"
                                                     style={{ fontSize: '0.8rem', marginLeft: '10px' }}
                                                 >
                                                     {pendingInterventions}
                                                 </span>
                                                 </Link>

                                                 </>
                                             )}
                                             <br></br>
                                            <small>{formattedDate(userData.lastConnection, "dd/MM/yyyy HH:mm")}</small>
                                         </div>
                  )}
                  <Menu/>
                </div>
              </Navbar>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}